/* eslint-disable @typescript-eslint/no-var-requires */
const {
  preset: marketsPreset,
} = require("@bloomberg/media-ui-markets/markets-preset");
/* eslint-enable @typescript-eslint/no-var-requires */

const CHART_COLORS = marketsPreset.theme.extend.colors;

const CHART_COLOR_BY_INDEX = [
  "#000",
  CHART_COLORS["chart-blue"],
  CHART_COLORS["chart-orange"],
  CHART_COLORS["chart-purple"],
  CHART_COLORS["chart-sky-blue"],
  CHART_COLORS["chart-red"],
  CHART_COLORS["chart-mustard"],
  CHART_COLORS["chart-pink"],
  CHART_COLORS["chart-green"],
  CHART_COLORS["chart-brown"],
];

export const DEFAULT_COMPARISON_TICKERS = [
  "INDU:IND",
  "SPX:IND",
  "CCMP:IND",
  "B500:IND",
];

export function getChartTickerColor(tickerPosition: number): string {
  if (tickerPosition >= CHART_COLOR_BY_INDEX.length) {
    return CHART_COLORS[0];
  }

  return CHART_COLOR_BY_INDEX[tickerPosition];
}
